export default {
      id: "big-lock-usage",
      viewBox: "0 0 107 124",
      url: __webpack_public_path__ + "sprite.svg#big-lock",
      toString: function () {
        return this.url;
      }
    }